"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerFooter = exports.Drawer = exports.closedMixin = exports.openedMixin = exports.ToggleButton = exports.ListItemText = exports.ListItemIcon = exports.ListItemButton = exports.ListItem = exports.leaveTransition = exports.enterTransition = exports.MENU_WIDTH_CLOSED = exports.MENU_WIDTH_OPEN = exports.MENU_ITEM_HOVER_COLOR = exports.MENU_ITEM_SELECTED_COLOR = exports.DARK_TEXT_SECONDARY = void 0;
const tslib_1 = require("tslib");
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const Drawer_1 = tslib_1.__importDefault(require("@mui/material/Drawer"));
const IconButton_1 = tslib_1.__importDefault(require("@mui/material/IconButton"));
const ListItem_1 = tslib_1.__importDefault(require("@mui/material/ListItem"));
const ListItemButton_1 = tslib_1.__importDefault(require("@mui/material/ListItemButton"));
const ListItemIcon_1 = tslib_1.__importDefault(require("@mui/material/ListItemIcon"));
const ListItemText_1 = tslib_1.__importDefault(require("@mui/material/ListItemText"));
const styles_1 = require("@mui/material/styles");
exports.DARK_TEXT_SECONDARY = "rgba(255, 255, 255, 0.70)";
exports.MENU_ITEM_SELECTED_COLOR = "rgba(255, 255, 255, 0.16)";
exports.MENU_ITEM_HOVER_COLOR = "rgba(255, 255, 255, 0.08)";
exports.MENU_WIDTH_OPEN = 280;
exports.MENU_WIDTH_CLOSED = 68;
const enterTransition = (theme) => theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
});
exports.enterTransition = enterTransition;
const leaveTransition = (theme) => theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
});
exports.leaveTransition = leaveTransition;
exports.ListItem = (0, styles_1.styled)(ListItem_1.default, { shouldForwardProp: (prop) => prop !== "open" })(({ theme }) => ({
    color: exports.DARK_TEXT_SECONDARY,
    padding: theme.spacing(0.5, 0, 0.5, 0),
}));
exports.ListItemButton = (0, styles_1.styled)(ListItemButton_1.default)(({ theme, selected }) => ({
    padding: theme.spacing(0, 0, 0, 1),
    borderRadius: theme.spacing(0.5),
    "&:hover": {
        background: !selected && exports.MENU_ITEM_HOVER_COLOR,
    },
    "&.Mui-selected": {
        color: theme.palette.secondary.main,
        background: exports.MENU_ITEM_SELECTED_COLOR,
    },
}));
exports.ListItemIcon = (0, styles_1.styled)(ListItemIcon_1.default)(() => ({
    color: "inherit",
    minWidth: "20px",
}));
exports.ListItemText = (0, styles_1.styled)(ListItemText_1.default, { shouldForwardProp: (prop) => prop !== "open" })(({ theme, open }) => ({
    paddingLeft: theme.spacing(2),
    opacity: open ? 1 : 0,
}));
exports.ToggleButton = (0, styles_1.styled)(IconButton_1.default)(({ theme }) => ({
    float: "right",
    marginLeft: "auto",
    width: theme.spacing(6),
    height: theme.spacing(6),
    marginRight: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
    color: exports.DARK_TEXT_SECONDARY,
}));
const openedMixin = (theme) => ({
    width: exports.MENU_WIDTH_OPEN,
    transition: (0, exports.enterTransition)(theme),
    overflowX: "hidden",
    background: theme.palette.common.black,
});
exports.openedMixin = openedMixin;
const closedMixin = (theme) => ({
    transition: (0, exports.leaveTransition)(theme),
    overflowX: "hidden",
    width: exports.MENU_WIDTH_CLOSED,
    background: theme.palette.common.black,
});
exports.closedMixin = closedMixin;
exports.Drawer = (0, styles_1.styled)(Drawer_1.default, { shouldForwardProp: (prop) => prop !== "open" })(({ theme, open }) => ({
    width: exports.MENU_WIDTH_OPEN,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    ...(open && {
        ...(0, exports.openedMixin)(theme),
        "& .MuiDrawer-paper": { ...(0, exports.openedMixin)(theme), height: "calc(100vh - 64px)" },
    }),
    ...(!open && {
        ...(0, exports.closedMixin)(theme),
        "& .MuiDrawer-paper": { ...(0, exports.closedMixin)(theme), height: "calc(100vh - 64px)" },
    }),
}));
exports.DrawerFooter = (0, styles_1.styled)(Box_1.default, { shouldForwardProp: (prop) => prop !== "open" })(({ theme, open }) => ({
    position: "fixed",
    width: "280px",
    bottom: 0,
    left: 0,
    borderRight: "1px solid rgba(0, 0, 0, 0.12)",
    ...(open && (0, exports.openedMixin)(theme)),
    ...(!open && (0, exports.closedMixin)(theme)),
}));
